import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/404_images/404.png';
import _imports_1 from '@/assets/404_images/404_cloud.png';
const _hoisted_1 = {
  class: "wscn-http404-container"
};
const _hoisted_2 = {
  class: "wscn-http404"
};
const _hoisted_3 = {
  class: "bullshit"
};
const _hoisted_4 = {
  class: "bullshit__headline"
};
const __default__ = {
  name: "Page404"
};
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    function message() {
      return "The webmaster said that you can not enter this page...";
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[3] || (_cache[3] = _createStaticVNode("<div class=\"pic-404\" data-v-1d929f9c><img class=\"pic-404__parent\" src=\"" + _imports_0 + "\" alt=\"404\" data-v-1d929f9c><img class=\"pic-404__child left\" src=\"" + _imports_1 + "\" alt=\"404\" data-v-1d929f9c><img class=\"pic-404__child mid\" src=\"" + _imports_1 + "\" alt=\"404\" data-v-1d929f9c><img class=\"pic-404__child right\" src=\"" + _imports_1 + "\" alt=\"404\" data-v-1d929f9c></div>", 1)), _createElementVNode("div", _hoisted_3, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "bullshit__oops"
      }, "OOPS!", -1)), _createElementVNode("div", _hoisted_4, _toDisplayString(message()), 1), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "bullshit__info"
      }, " Please check that the URL you entered is correct, or click the button below to return to the homepage. ", -1)), _cache[2] || (_cache[2] = _createElementVNode("a", {
        href: "",
        class: "bullshit__return-home"
      }, "Back to home", -1))])])]);
    };
  }
});